export const groupManagementLabel = 'Group management';
// need to split up common options for sonarqube duplicate lines issue
const adminUserActivityOptions = [
  {
    label: 'Admin user activity',
    options: [
      { label: 'User login success', value: 'User login success' },
      { label: 'User logout', value: 'User logout' },
    ],
  },
];
const roleManagementOptions = [
  {
    label: 'Role management',
    options: [
      {
        label: 'Role assigned to users',
        value: 'Role assigned to users',
      },
      {
        label: 'Role removed from users',
        value: 'Role removed from users',
      },
      {
        label: 'Role assigned to groups',
        value: 'Role assigned to groups',
      },
      {
        label: 'Role removed from groups',
        value: 'Role removed from groups',
      },
    ],
  },
];
const userOptions = [
  {
    label: 'User management',
    options: [
      {
        label: 'User deleted',
        value: 'User deleted',
      },
      {
        label: 'Users invited',
        value: 'Users invited',
      },
    ],
  },
  {
    label: 'User migration',
    options: [
      {
        label: 'Migration started',
        value: 'Migration started',
      },
      {
        label: 'Skipped user',
        value: 'Skipped user',
      },
      {
        label: 'Validation failed',
        value: 'Validation failed',
      },
      {
        label: 'User migration failed',
        value: 'User migration failed',
      },
      {
        label: 'Migration run completed',
        value: 'Migration run completed',
      },
      {
        label: 'User created',
        value: 'User created',
      },
    ],
  },
];
const mspRelationshipManagementOptions = [
  {
    label: 'Relationship management',
    options: [
      {
        label: 'Relationship created',
        value: 'Relationship created',
      },
      {
        label: 'Relationship revoked',
        value: 'Relationship revoked',
      },
    ],
  },
];
const groupManagementOptions = [
  {
    label: groupManagementLabel,
    options: [
      {
        label: 'Group created',
        value: 'New group added',
      },
      {
        label: 'Group deleted',
        value: 'Group deleted',
      },
      {
        label: 'Users added to group',
        value: 'Users added to group',
      },
      {
        label: 'Users removed from group',
        value: 'Users removed from group',
      },
    ],
  },
];
export const mspGroupManagementOptions = [
  {
    label: groupManagementLabel,
    options: [
      {
        label: 'Group created',
        value: 'New group added',
      },
      {
        label: 'Group deleted',
        value: 'Group deleted',
      },
      {
        label: 'Group shared',
        value: 'Group shared',
      },
      {
        label: 'Group unshared',
        value: 'Group unshared',
      },
      {
        label: 'Users added to group',
        value: 'Users added to group',
      },
      {
        label: 'Users removed from group',
        value: 'Users removed from group',
      },
    ],
  },
];
export const eventTypesSubTypesOptions = [
  ...adminUserActivityOptions,
  ...groupManagementOptions,
  ...roleManagementOptions,
  ...userOptions,
];

export const MSPEventSubTypesOptions = [
  ...adminUserActivityOptions,
  ...mspGroupManagementOptions,
  ...mspRelationshipManagementOptions,
  ...roleManagementOptions,
  ...userOptions,
];
export const excludedField = 'userSelectedDateRange';
